import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

/* Layout */
import Layout from '@/layout'
import LayoutChildren from '@/views/layout/index.vue'

/* Router Modules */

/**
 * Note: sub-menu only appear when route children.length >= 1
 * Detail see: https://panjiachen.github.io/vue-element-admin-site/guide/essentials/router-and-nav.html
 *
 * hidden: true                   if set true, item will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu
 *                                if not set alwaysShow, when item has more than one children route,
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noRedirect           if set noRedirect will no redirect in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    roles: ['admin','editor']    control the page roles (you can set multiple roles)
    title: 'title'               the name show in sidebar and breadcrumb (recommend set)
    icon: 'svg-name'/'el-icon-x' the icon show in the sidebar
    noCache: true                if set true, the page will no be cached(default is false)
    affix: true                  if set true, the tag will affix in the tags-view
    breadcrumb: false            if set false, the item will hidden in breadcrumb(default is true)
    activeMenu: '/example/list'  if set path, the sidebar will highlight the path you set
  }
 */

/**
 * constantRoutes
 * a base page that does not have permission requirements
 * all roles can be accessed
 */
export const constantRoutes = [
  {
    path: '/redirect',
    component: Layout,
    hidden: true,
    children: [{
      path: '/redirect/:path(.*)',
      component: () =>
        import('@/views/redirect/index')
    }]
  },

  // 登陆页面
  {
    path: '/login',
    component: () =>
      import('@/views/login/index'),
    hidden: true
  },
  {
    path: '/auth-redirect',
    component: () =>
      import('@/views/login/auth-redirect'),
    hidden: true
  },
  {
    path: '/404',
    component: () =>
      import('@/views/error-page/404'),
    hidden: true
  },
  {
    path: '/401',
    component: () =>
      import('@/views/error-page/401'),
    hidden: true
  },
  {
    path: '/',
    component: Layout,
    redirect: '/dashboard',
    hidden: true,
    children: [
      {
        path: '/dashboard',
        component: () =>
          import('@/views/dashboard/index'),
        name: 'Dashboard',
        meta: {
          title: '工作台',
          icon: 'dashboard',
          affix: true

        }
      },
      {
        path: '/profile/index',
        component: () =>
          import('@/views/profile/index'),
        name: '/profile/index',
        meta: {
          title: '资料修改'
        }
      },

      // 促销方案详情
      {
        path: '/discountsDetail',
        component: () =>
          import('@/views/mshop_merchant/promotion/manage/detail'),
        name: 'discountsDetail',
        meta: {
          title: '促销方案详情',
          icon: '',
          breadcrumb: false,
          keepAlive: false
          // affix: true
        }
      },
      // 盘点单详情
      {
        path: '/inventorycheckDetail',
        component: () =>
          import('@/views/mshop_merchant/inventory/inventorycheck/detail'),
        name: 'inventorycheckDetail',
        meta: {
          title: '编辑盘点单',
          icon: '',
          breadcrumb: false,
          keepAlive: false
        }
      },
      // 存油盘点单详情
      {
        path: '/GasStorageStocktakingDetail',
        component: () =>
          import('@/views/GasStation/GasStorage/GasStorageStocktaking/detail'),
        name: 'GasStorageStocktakingDetail',
        meta: {
          title: '编辑盘点单',
          icon: '',
          breadcrumb: false,
          keepAlive: false
        }
      },
      // 差异单详情
      {
        path: '/inventorydiffDetail',
        component: () =>
          import('@/views/mshop_merchant/inventory/inventory_diff/detail'),
        name: 'inventorydiffDetail',
        meta: {
          title: '编辑差异单',
          icon: '',
          breadcrumb: false,
          keepAlive: false
        }
      },
      // 调整单详情
      {
        path: '/inventoryadjustDetail',
        component: () =>
          import('@/views/mshop_merchant/inventory/inventory_adjust/detail'),
        name: 'inventoryadjustDetail',
        meta: {
          title: '编辑调整单',
          icon: '',
          breadcrumb: false,
          keepAlive: false
        }
      },
      // 调价单详情
      {
        path: '/adjustPricetDetail',
        component: () =>
          import('@/views/mshop_goods/goods/adjust_price/details'),
        name: 'adjustPricetDetail',
        meta: {
          title: '编辑调价单',
          icon: '',
          breadcrumb: false,
          keepAlive: false
        }
      },
      // 线上商城调价单详情
      {
        path: '/adjustShopPricetDetail',
        component: () =>
          import('@/views/mshop_goods/goods/adjust_shopprice/details'),
        name: 'adjustShopPricetDetail',
        meta: {
          title: '编辑线上商品调价单',
          icon: '',
          breadcrumb: false,
          keepAlive: false
        }
      },
      {
        path: '/purchaseOrderDetail',
        component: () =>
          import('@/views/mshop_goods/purchase/purchaseOrder_detail'),
        name: 'purchaseOrderDetail',
        meta: {
          title: '编辑采购单', icon: '',
          affix: false,
          keepAlive: false
        }

      },
      {
        path: '/purchaseReceiptDetail',
        component: () =>
          import('@/views/mshop_goods/purchase/purchaseReceipt_detail'),
        name: 'purchaseReceiptDetail',
        meta: {
          title: '编辑采购收货单', icon: '',
          affix: false,
          keepAlive: false
        }

      },
      {
        path: '/GasPurchaseOrderListDetail',
        component: () =>
          import('@/views/GasStation/GasPurchase/GasPurchaseOrderList/detail'),
        name: 'GasPurchaseOrderListDetail',
        meta: {
          title: '进油单详情', icon: '',
          affix: false,
          keepAlive: false
        }

      },
      {
        path: 'GasStationListDetail',
        component: () => import('@/views/GasStation/GasStationManagement/GasStationList/detail.vue'),
        name: 'GasStationListDetail',
        meta: { title: '新增油站', icon: '' }
      },
      {
        path: '/purchaseReturnDetail',
        component: () =>
          import('@/views/mshop_goods/purchase/purchaseReturn_detail'),
        name: 'purchaseReturnDetail',
        meta: {
          title: '编辑采购退货单',
          icon: '',
          affix: false,
          keepAlive: false
        }

      },
      {
        path: '/wholesaleOrderDetail',
        component: () =>
          import('@/views/mshop_merchant/wholesale/wholesale_order_detail'),
        name: 'wholesaleOrderDetail',
        meta: {
          title: '编辑批发订单',
          icon: '',
          affix: false,
          keepAlive: false
        }

      },
      {
        path: '/wholesaleSellDetail',
        component: () =>
          import('@/views/mshop_merchant/wholesale/wholesale_sell_detail'),
        name: 'wholesaleSellDetail',
        meta: {
          title: '编辑批发销售单',
          icon: '',
          affix: false,
          keepAlive: false
        }

      },
      {
        path: '/wholesaleSalesDetail',
        component: () =>
          import('@/views/mshop_merchant/wholesale/wholesale_sales_detail'),
        name: 'wholesaleSalesDetail',
        meta: {
          title: '编辑批发退货单',
          icon: '',
          affix: false,
          keepAlive: false
        }

      },
      {
        path: '/distributionEnquiryDetail',
        component: () =>
          import('@/views/mshop_merchant/distribution/distribution_enquiry_detail'),
        name: 'distributionEnquiryDetail',
        meta: {
          title: '编辑要货单',
          icon: '',
          affix: false,
          keepAlive: false
        }

      },
      {
        path: '/distributionDeliveryDetail',
        component: () =>
          import('@/views/mshop_merchant/distribution/distribution_delivery_detail'),
        name: 'distributionDeliveryDetail',
        meta: {
          title: '编辑配送单',
          icon: '',
          affix: false,
          keepAlive: false
        }

      },
      {
        path: '/addshopping',
        component: () =>
          import('@/views/mshop_merchant/promotion/manage/addshopping'),
        name: 'addshopping',
        meta: {
          title: '添加商品',
          icon: '',
          keepAlive: false
        }

      },
      {
        path: '/payment',
        component: () =>
          import('@/views/payment/index'),
        name: 'payment',
        meta: {
          title: '支付页面',
          icon: '',
          keepAlive: false
        }

      }

    ]
  },
  // // 收银页面
  {
    path: '/cash',
    component: () =>
      import('@/views/mshop_merchant/cash/cashier.vue'),
    hidden: true,
    meta: {
      title: '收银',
      icon: 'dashboard',
      affix: true

    },
    children: [
      {
        path: '/cash',
        component: () => import('@/views/mshop_merchant/cash/index.vue'),
        name: 'cashier',
        menu_name: '收银台',
        meta: {
          title: '收银台',
          icon: 'user'
        }
      },
      {
        path: '/order',
        component: () => import('@/views/mshop_merchant/cash/order.vue'),
        name: 'order',
        menu_name: '订单',
        meta: {
          title: '订单',
          icon: 'user',
          keepAlive: true // 设置缓存
        }
      },
      {
        path: '/posMember',
        component: () => import('@/views/mshop_merchant/cash/posMember.vue'),
        name: 'posMember',
        menu_name: '会员',
        meta: {
          title: '会员',
          icon: 'user'
        }
      },
      {
        path: '/credit',
        component: () => import('@/views/mshop_merchant/cash/credit.vue'),
        name: 'credit',
        menu_name: '挂单',
        meta: {
          title: '挂单',
          icon: 'user'
        }
      }
    ]
    // hidden: true
  }
  // {
  //   path: '/cash',
  //   component: () =>
  //     import('@/views/mshop_merchant/cash/index'),
  //   hidden: true,
  //   meta: {
  //     title: '收银',
  //     icon: 'dashboard'
  //     // affix: true

  //   },
  //   children: [
  //     { path: '/cash/cashier',
  //       component: () => import('@/views/mshop_merchant/cash/cashier.vue'),
  //       name: 'cashier',
  //       menu_name: '收银台',
  //       meta: {
  //         title: '收银台',
  //         icon: 'user'
  //       }}
  //   ]
  // // hidden: true
  // },
  // {
  //   path: '/dashboard',
  //   component: Layout,
  //   name: 'dashboard',
  //   menu_name: '工作台',
  //   meta: {
  //     title: '工作台',
  //     icon: 'chart'
  //   }
  // },
  // {
  //   path: '/',
  //   component: Layout,
  //   name: 'cash',
  //   menu_name: '收银台',
  //   meta: {
  //     title: '收银台',
  //     icon: 'money'
  //   }
  // },
  // {
  //   path: '/GasStation',
  //   component: Layout,
  //   name: 'GasStation',
  //   menu_name: '加油站',
  //   meta: {
  //     title: '加油站',
  //     icon: 'tree'
  //   },
  //   children: [
  //     {
  //       path: '/GasStationManagement',
  //       component: LayoutChildren,
  //       name: 'GasStationManagement',
  //       menu_name: '油站管理',
  //       meta: {
  //         title: '油站管理',
  //         icon: 'user'
  //       },
  //       children: [
  //         {
  //           path: '/GasStation/GasStationManagement/GasStationList',
  //           component: () => import('@/views/GasStation/GasStationManagement/GasStationList/index.vue'),
  //           name: 'GasStationList',
  //           meta: { title: '油站列表', icon: '' }
  //         },
  //
  //         {
  //           path: '/GasStation/GasStationManagement/GasTankConfig',
  //           component: () => import('@/views/GasStation/GasStationManagement/GasTankConfig/index.vue'),
  //           name: 'GasTankConfig',
  //           meta: { title: '油罐配置', icon: '' }
  //         },
  //         {
  //           path: '/GasStation/GasStationManagement/GasGunConfig',
  //           component: () => import('@/views/GasStation/GasStationManagement/GasGunConfig/index.vue'),
  //           name: 'GasGunConfig',
  //           meta: { title: '油枪配置', icon: '' }
  //         }
  //       ]
  //     },
  //     {
  //       path: '/GasProduct',
  //       component: LayoutChildren,
  //       name: 'GasProduct',
  //       meta: {
  //         title: '油品',
  //         icon: 'user'
  //       },
  //       children: [
  //         {
  //           path: '/GasStation/GasProduct/GasProductManagement',
  //           component: () => import('@/views/GasStation/GasProduct/GasProductManagement/index.vue'),
  //           name: 'GasProductManagement',
  //           meta: { title: '油品管理', icon: '' }
  //         },
  //         {
  //           path: '/GasStation/GasProduct/GasPriceAdjustment',
  //           component: () => import('@/views/GasStation/GasProduct/GasPriceAdjustment/index.vue'),
  //           name: 'GasPriceAdjustment',
  //           meta: { title: '油品油价', icon: '' }
  //         },
  //         {
  //           path: '/GasStation/GasProduct/OilNumberManagement',
  //           component: () => import('@/views/GasStation/OilNumberManagement/index.vue'),
  //           name: 'OilNumberManagement',
  //           meta: { title: '油编管理', icon: '' }
  //         }
  //       ]
  //     },
  //     {
  //       path: '/GasPurchase',
  //       component: LayoutChildren,
  //       name: 'GasPurchase',
  //       meta: {
  //         title: '进油',
  //         icon: 'user'
  //       },
  //       children: [
  //         {
  //           path: '/GasStation/GasPurchase/GasPurchaseOrderList',
  //           component: () => import('@/views/GasStation/GasPurchase/GasPurchaseOrderList/index.vue'),
  //           name: 'GasPurchaseOrderList',
  //           meta: { title: '进油单列表', icon: '' }
  //         },
  //         {
  //           path: '/GasStation/GasPurchase/GasSupplier',
  //           component: () => import('@/views/GasStation/GasPurchase/GasSupplier/index.vue'),
  //           name: 'GasSupplier',
  //           meta: { title: '油品供应商', icon: '' }
  //         },
  //         {
  //           path: '/GasStation/GasPurchase/GasStatistics',
  //           component: () => import('@/views/GasStation/GasPurchase/GasStatistics/index.vue'),
  //           name: 'GasStatistics',
  //           meta: { title: '进油统计', icon: '' }
  //         }
  //       ]
  //     },
  //     {
  //       path: '/GasStorage',
  //       component: LayoutChildren,
  //       name: 'GasStorage',
  //       meta: {
  //         title: '存油',
  //         icon: 'user'
  //       },
  //       children: [
  //         {
  //           path: '/GasStation/GasStorage/GasStorageStatistics',
  //           component: () => import('@/views/GasStation/GasStorage/GasStorageStatistics/index.vue'),
  //           name: 'GasStorageStatistics',
  //           meta: { title: '存油统计', icon: '' }
  //         },
  //         {
  //           path: '/GasStation/GasStorage/GasStorageTrack',
  //           component: () => import('@/views/GasStation/GasStorage/GasStorageTrack/index.vue'),
  //           name: 'GasStorageTrack',
  //           meta: { title: '存油跟踪', icon: '' }
  //         },
  //         {
  //           path: '/GasStation/GasStorage/GasStorageStocktaking',
  //           component: () => import('@/views/GasStation/GasStorage/GasStorageStocktaking/index.vue'),
  //           name: 'GasStorageStocktaking',
  //           meta: { title: '存油盘点', icon: '' }
  //         }
  //       ]
  //     }
  //   ]
  // },
  // {
  //   path: '/mshop_merchant',
  //   component: Layout,
  //   name: 'mshop_merchant',
  //   menu_name: '便利店',
  //   meta: {
  //     title: '便利店',
  //     icon: 'shopping'
  //   },
  //   children: [
  //     {
  //       path: '/mshop_merchant',
  //       component: LayoutChildren,
  //       name: 'mshop_merchant',
  //       menu_name: '采购',
  //       meta: {
  //         title: '采购',
  //         icon: 'component'
  //       },
  //       children: [
  //         {
  //           path: '/mshop_merchant/purchase/purchase_receipt',
  //           component: () => import('@/views/mshop_merchant/purchase/purchase_receipt.vue'),
  //           name: 'purchase_receipt',
  //           meta: { title: '采购收货单', icon: '' }
  //         },

  //         {
  //           path: '/mshop_merchant/purchase/purchase_return',
  //           component: () => import('@/views/mshop_merchant/purchase/purchase_return.vue'),
  //           name: 'purchase_return',
  //           meta: { title: '采购退货单', icon: '' }
  //         },
  //         {
  //           path: '/mshop_merchant/purchase/purchase_report',
  //           component: () => import('@/views/mshop_merchant/purchase/purchase_report.vue'),
  //           name: 'purchase_report',
  //           meta: { title: '采购汇总', icon: '' }
  //         }
  //       ]
  //     },
  //     {
  //       path: '/mshop_goods',
  //       component: LayoutChildren,
  //       name: 'mshop_goods',
  //       meta: {
  //         title: '商品',
  //         icon: 'component'
  //       },
  //       children: [
  //         {
  //           path: '/mshop_merchant/goods/sort/index',
  //           component: () => import('@/views/mshop_goods/goods/sort/index.vue'),
  //           name: 'sort',
  //           meta: { title: '商品类别', icon: '' }
  //         },
  //         {
  //           path: '/mshop_merchant/goods/goods_unit',
  //           component: () => import('@/views/mshop_goods/goods/goods_unit.vue'),
  //           name: 'goods_unit',
  //           meta: { title: '商品单位', icon: '' }
  //         },
  //         {
  //           path: '/mshop_merchant/goods/supplier/index',
  //           component: () => import('@/views/mshop_goods/goods/supplier/index.vue'),
  //           name: 'supplier',
  //           meta: { title: '供应商', icon: '' }
  //         },
  //         {
  //           path: '/mshop_merchant/goods/goods_manage',
  //           component: () => import('@/views/mshop_goods/goods/goods_manage.vue'),
  //           name: 'goods_manage',
  //           meta: { title: '商品列表', icon: '' }
  //         }
  //       ]
  //     },
  //     {
  //       path: '/mshop_merchant',
  //       component: LayoutChildren,
  //       name: 'mshop_merchant',
  //       meta: {
  //         title: '库存',
  //         icon: 'component'
  //       },
  //       children: [
  //         {
  //           path: '/mshop_merchant/inventory/inventory_list/index',
  //           component: () => import('@/views/mshop_merchant/inventory/inventory_list/index.vue'),
  //           name: 'inventory_list',
  //           meta: { title: '库存查询', icon: '' }
  //         },
  //         {
  //           path: '/mshop_merchant/inventory/inventoryrecord/index',
  //           component: () => import('@/views/mshop_merchant/inventory/inventoryrecord/index.vue'),
  //           name: 'inventoryrecord',
  //           meta: { title: '出入库明细', icon: '' }
  //         },
  //         {
  //           path: '/mshop_merchant/inventory/inventorycheck/index',
  //           component: () => import('@/views/mshop_merchant/inventory/inventorycheck/index.vue'),
  //           name: 'inventorycheck',
  //           meta: { title: '库存盘点单', icon: '' }
  //         }
  //       ]
  //     }
  //   ]
  // },
  // {
  //   path: '/member',
  //   component: Layout,
  //   name: 'member',
  //   menu_name: '会员',
  //   meta: {
  //     title: '会员',
  //     icon: 'people'
  //   },
  //   children: [
  //     {
  //       path: '/member/memberManagement',
  //       component: LayoutChildren,
  //       name: 'memberManagement',
  //       menu_name: '会员管理',
  //       meta: {
  //         title: '会员管理',
  //         icon: 'user'
  //       },
  //       children: [
  //         {
  //           path: '/member/memberManagement/memberProfile',
  //           component: () => import('@/views/member/memberManagement/memberProfile/index.vue'),
  //           name: 'memberProfile',
  //           menu_name: '会员档案',
  //           meta: {
  //             title: '会员档案',
  //             icon: 'user'
  //           }
  //         },
  //         {
  //           path: '/member/memberManagement/memberSettings',
  //           component: () => import('@/views/member/memberManagement/memberSettings/index.vue'),
  //           name: 'memberSettings',
  //           menu_name: '会员设置',
  //           meta: {
  //             title: '会员设置',
  //             icon: 'user'
  //           }
  //         }
  //       ]
  //     },
  //     {
  //       path: '/member/creditManagement',
  //       component: LayoutChildren,
  //       name: 'creditManagement',
  //       menu_name: '挂账管理',
  //       meta: {
  //         title: '挂账管理',
  //         icon: 'user'
  //       },
  //       children: [
  //         {
  //           path: '/member/creditManagement/creditUnit',
  //           component: () => import('@/views/member/creditManagement/creditUnit/index.vue'),
  //           name: 'creditUnit',
  //           menu_name: '挂账单位',
  //           meta: {
  //             title: '挂账单位',
  //             icon: 'user'
  //           }
  //         },
  //         {
  //           path: '/member/memberManagement/creditUnit/creditLog',
  //           component: () => import('@/views/member/creditManagement/creditUnit/creditLog.vue'),
  //           name: 'CreditLog',
  //           menu_name: '挂账记录',
  //           meta: {
  //             title: '挂账记录',
  //             icon: 'user'
  //           }
  //         },
  //         {
  //           path: '/member/memberManagement/creditUnit/creditOrder',
  //           component: () => import('@/views/member/creditManagement/creditUnit/creditOrder.vue'),
  //           name: 'CreditOrder',
  //           menu_name: '挂账结算',
  //           meta: {
  //             title: '挂账结算',
  //             icon: 'user'
  //           }
  //         }
  //       ]
  //     }
  //   ]
  // },
  // {
  //   path: '/marketing',
  //   component: Layout,
  //   name: 'marketing',
  //   menu_name: '营销',
  //   meta: {
  //     title: '营销',
  //     icon: 'example'
  //   },
  //   children: [
  //     {
  //       path: '/marketing/marketingProgram',
  //       component: LayoutChildren,
  //       name: 'marketingProgram',
  //       menu_name: '营销方案',
  //       meta: {
  //         title: '营销方案',
  //         icon: 'user'
  //       },
  //       children: [
  //         {
  //           path: '/marketing/marketingProgram/specialOffer',
  //           component: () => import('@/views/marketing/marketingProgram/specialOffer/index.vue'),
  //           name: 'specialOffer',
  //           menu_name: '优惠活动',
  //           meta: {
  //             title: '优惠活动',
  //             icon: 'user'
  //           }
  //         },
  //         {
  //           path: '/marketing/marketingProgram/RollMarketing',
  //           component: () => import('@/views/marketing/marketingProgram/RollMarketing/index.vue'),
  //           name: 'RollMarketing',
  //           menu_name: '卡券营销',
  //           meta: {
  //             title: '卡券营销',
  //             icon: 'user'
  //           }
  //         }
  //       ]
  //     }
  //   ]
  // },

  // {
  //   path: '/report',
  //   component: Layout,
  //   name: 'report',
  //   menu_name: '报表',
  //   meta: {
  //     title: '报表',
  //     icon: 'documentation'
  //   },
  //   children: [
  //     {
  //       path: '/Cashier',
  //       component: LayoutChildren,
  //       name: 'Cashier',
  //       menu_name: '收银',
  //       meta: {
  //         title: '收银',
  //         icon: 'user'
  //       },
  //       children: [
  //         {
  //           path: '/report/Cashier/Statement',
  //           component: () => import('@/views/report/Cashier/Statement/index.vue'),
  //           name: 'Statement',
  //           meta: { title: '收银流水', icon: '' }
  //         },
  //
  //         {
  //           path: '/report/Cashier/Daily',
  //           component: () => import('@/views/report/Cashier/Daily/index.vue'),
  //           name: 'Daily',
  //           meta: { title: '收银日报', icon: '' }
  //         },
  //         {
  //           path: '/report/Cashier/Reconciliation',
  //           component: () => import('@/views/report/Cashier/Reconciliation/index.vue'),
  //           name: 'Reconciliation',
  //           meta: { title: '收银对账', icon: '' }
  //         }
  //       ]
  //     },
  //     {
  //       path: '/Sale',
  //       component: LayoutChildren,
  //       name: 'Sale',
  //       meta: {
  //         title: '销售',
  //         icon: 'user'
  //       },
  //       children: [
  //         {
  //           path: '/report/Sale/Revenue',
  //           component: () => import('@/views/report/Sale/Revenue/index.vue'),
  //           name: 'Revenue',
  //           meta: { title: '销售流水', icon: '' }
  //         },
  //         {
  //           path: '/report/Sale/Statistics',
  //           component: () => import('@/views/report/Sale/Statistics/index.vue'),
  //           name: 'Statistics',
  //           meta: { title: '销售统计', icon: '' }
  //         },
  //         {
  //           path: '/report/Sale/Analysis',
  //           component: () => import('@/views/report/Sale/Analysis/index.vue'),
  //           name: 'Analysis',
  //           meta: { title: '销售分析', icon: '' }
  //         }
  //       ]
  //     }
  //   ]
  // },
  //
  // {
  //   path: '/setting',
  //   component: Layout,
  //   name: 'setting',
  //   menu_name: '系统',
  //   meta: {
  //     title: '系统',
  //     icon: 'list'
  //   },
  //   children: [
  //     {
  //       path: '/layout',
  //       component: LayoutChildren,
  //       name: 'layout',
  //       menu_name: '系统管理',
  //       meta: {
  //         title: '系统管理',
  //         icon: ''
  //       },
  //       children: [
  //         {
  //           path: '/mshop_user/role/role_manage',
  //           component: () => import('@/views/mshop_user/role/role_manage.vue'),
  //           name: 'role_manage',
  //           menu_name: '角色管理',
  //           meta: {
  //             title: '角色管理',
  //             icon: ''
  //           }
  //         },
  //         {
  //           path: '/mshop_user/user/user_manage',
  //           component: () => import('@/views/mshop_user/user/user_manage.vue'),
  //           name: 'user_manage',
  //           menu_name: '员工管理',
  //           meta: {
  //             title: '员工管理',
  //             icon: ''
  //           }
  //         }
  //       ]
  //     }
  //   ]
  // }
]

/**
 * asyncRoutes
 * the routes that need to be dynamically loaded based on user roles
 * hidden: true                   if set true, item will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu
 *                                if not set alwaysShow, when item has more than one children route,
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noRedirect           if set noRedirect will no redirect in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    roles: ['admin','editor']    control the page roles (you can set multiple roles)
    title: 'title'               the name show in sidebar and breadcrumb (recommend set)
    icon: 'svg-name'/'el-icon-x' the icon show in the sidebar
    noCache: true                if set true, the page will no be cached(default is false)
    affix: true                  if set true, the tag will affix in the tags-view
    breadcrumb: false            if set false, the item will hidden in breadcrumb(default is true)
    activeMenu: '/example/list'  if set path, the sidebar will highlight the path you set
  }
 */
export default new Router({
  mode: 'history', // 去掉url中的#
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRoutes
})

